export function testimonialsSlider() {
    let $slider = $(".testimonials-slider");
    $slider.slick({
        infinite: true,
        cssEase: "linear",
        arrows: true,
        dots: true,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 3000
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/testimonialsSlider.js